function StatsCard({ title, value, icon, color }) {
  return (
    <div style={{ ...styles.card, borderTop: `4px solid ${color}` }}>
      <div style={styles.top}>
        <div>
          <p style={styles.title}>{title}</p>
          <h2 style={styles.value}>{value}</h2>
        </div>
        <div style={{ ...styles.icon, backgroundColor: `${color}20` }}>
          <span style={{ fontSize: '28px' }}>{icon}</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
    flex: 1,
    minWidth: '200px'
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    margin: '0 0 8px 0',
    color: '#718096',
    fontSize: '14px',
    fontWeight: '500'
  },
  value: {
    margin: '0',
    fontSize: '32px',
    fontWeight: '700',
    color: '#1a1a2e'
  },
  icon: {
    width: '56px',
    height: '56px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default StatsCard;